export default [
    {
        insuranceNomineeRelation: "Spouse",
    },
    {
        insuranceNomineeRelation: "Father",
    },
    {
        insuranceNomineeRelation: "Mother",
    },
    {
        insuranceNomineeRelation: "Son",
    },
    {
        insuranceNomineeRelation: "Daughter",
    },
];
